module.exports = __webpack_public_path__ + "static/media/confianca.42a4f7ff.png";